import axios from "axios";
export default axios.create({
  baseURL:`${process.env.REACT_APP_API}`,
  //baseURL: "http://rdocsapi2.use.rpost.net/api/v1", 
  //baseURL: "https://localhost:44386/api/v1", 
  
  headers: {
    "Content-type": "application/json"
  }
});